import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from './ui/button';
import { Eraser, Check } from 'lucide-react';

const SignaturePad = forwardRef(({ onChange, label = "Unterschrift", required = false }, ref) => {
  const sigCanvasRef = useRef(null);

  useImperativeHandle(ref, () => ({
    clear: () => {
      sigCanvasRef.current?.clear();
      onChange?.(null);
    },
    isEmpty: () => sigCanvasRef.current?.isEmpty() ?? true,
    getDataURL: () => {
      if (sigCanvasRef.current?.isEmpty()) return null;
      return sigCanvasRef.current?.toDataURL('image/png');
    }
  }));

  const handleEnd = () => {
    if (!sigCanvasRef.current?.isEmpty()) {
      const dataURL = sigCanvasRef.current.toDataURL('image/png');
      onChange?.(dataURL);
    }
  };

  const handleClear = () => {
    sigCanvasRef.current?.clear();
    onChange?.(null);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-semibold text-gray-900">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="border-2 border-gray-300 rounded-xl bg-white overflow-hidden">
        <SignatureCanvas
          ref={sigCanvasRef}
          penColor="black"
          canvasProps={{
            className: 'w-full h-40',
            style: { width: '100%', height: '160px' }
          }}
          onEnd={handleEnd}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-xs text-gray-500">Bitte mit Maus oder Finger unterschreiben</p>
        <Button 
          type="button" 
          variant="outline" 
          size="sm" 
          onClick={handleClear}
          className="text-xs"
        >
          <Eraser className="w-3 h-3 mr-1" />
          Löschen
        </Button>
      </div>
    </div>
  );
});

SignaturePad.displayName = 'SignaturePad';

export default SignaturePad;
